module.exports = __webpack_public_path__ + "img/green-booth-table-4.a34e11f9.png";